import type {Insight} from "../../../models/api/insight/Insight";
import {InsightTypeEnum} from "../../../models/api/insight/InsightTypeEnum";
import {KategorieEnum} from "../../../models/api/insight/KategorieEnum";
import {LizenzEnum} from "../../../models/api/insight/LizenzEnum";

const insights: Array<Insight> = [
    {
        id: "20250911-mobil",
        datum: "11.09.2025",
        kategorie: KategorieEnum.MOBILGERAETE_APP,
        type: InsightTypeEnum.VERBESSERTES_FEATURE,
        title: "Mobile-App v6.0.10",
        lizenz: [LizenzEnum.PRO, LizenzEnum.KURSE, LizenzEnum.FREE],
        content: [
            "Das aktuelle Update ermöglicht die Änderung von eigenen Daten über die App. Außerdem fixt es einen Bug" +
            "in der Androidversion (Menü).",
        ],
        aktions: [],
    },
];

export {
    insights,
};
